import styled from "styled-components";
import { IDefaultBody } from "./interface";

const Container = styled.div<IDefaultBody>`
    display: flex;
    flex-direction: column;
    background: var(--panel-head);
    padding: 1rem 0.5rem 0.2rem 0.5rem;
    @media(max-width: 600px){
        padding: 1rem 0.25rem 0.2rem 0.25rem;
    }

    ${(props) => props.maxHeight ? `
        overflow-y: scroll;
        overflow-x: hidden;
        max-height: ${props.maxHeight}px;
    `: ""}

    ${(props) => props.padding ? `
        padding: ${props.padding};
    ` : ""}
`;

export default Container;
